/* eslint-disable prefer-destructuring */

import { compareDate } from '../constants/sort';
import { PUBLISHED, SUBMITTED_FOR_REVIEW, UNMODIFIED } from '../constants/status';
import {INVALID_URL, INVALID_PHONE, INVALID_CURRENCY} from '../constants/validationErrorMsg';
export const schemaLoader = validators => {
  // data_type = [EMAIL, URL, NUMBER, STRING, PHONE, CURRENCY]
  // data_min
  // data_max
  // data_required Boolean
  const {data_type, data_min, data_max, data_required, pattern} = validators;
  const schemaV = {};
  let dataType = '';
  if (!data_type) {
    dataType = 'string';
  } else {
    //phone, currency, url needs to be string with pattern, others just as is
    switch (data_type?.toLowerCase()) {
      case 'phone':
      {
        dataType = 'string';
        schemaV.pattern = /^[0-9]{10}$/g;
        schemaV.messages = {stringPattern: INVALID_PHONE};
        break;
      }
      case 'currency': {
        dataType = 'string';
        schemaV.pattern = /^[0-9]*(\.[0-9]{2})?$/g;
        schemaV.messages = {stringPattern: INVALID_CURRENCY};
        break;
      }
      case 'url': {
        dataType = 'string';
        schemaV.pattern = /(https?:\/\/(?:www[0-9]?\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www[0-9]?\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www[0-9]?\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www[0-9]?\.[a-zA-Z0-9]+\.[^\s]{2,})$/;
        schemaV.messages = {stringPattern: INVALID_URL};
        break;
      }
      case 'Datepicker': {
        dataType = 'string';
        schemaV.pattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        schemaV.messages = {stringPattern: 'Incorrect pattern'};
        break;
      }
      case 'number': {
        dataType = data_type.toLowerCase();
        break;
      }
      default:
        dataType = data_type.toLowerCase();
    }
  }
  schemaV.type = dataType;

  if (data_required && dataType === 'string') {
    schemaV.empty = false;
  }
  if (!data_required) {
    schemaV.optional = true;
  }

  if (data_min !== '' && data_min !== null) {
    schemaV.min = data_min;
  }
  if (data_max !== '' && data_max !== null) {
    schemaV.max = data_max;
  }

  if (pattern) {
    schemaV.pattern = pattern;
  }
  if (dataType !== 'string') {
    schemaV.convert = true;
  }
  //zip only
  //if(data_type==='zip'){
  //    schemaV='string|numeric|length:5'
  //}
  //console.log(schemaV);
  return schemaV;
};

export const hasValue = obj => {
  for (const [, value] of Object.entries(obj)) {
    if (value) {
      return true;
    }
  }
  return false;
};

export const getModuleNamesByIds = (sampledata, ids) => {
  const res = sampledata.modules?.map(({id, title}) => {
    if (ids?.includes(id)) {
      return title;
    }
  });
  const result = res?.filter(element => element !== undefined);
  return result||[];
};

export const alertShow = (id, errId) => {
  if (id) {
    if (!id.includes('error')) {
      document.getElementById(id).style.display = 'block';
      setTimeout(() => {
        const modal = document.getElementById(id);
        if(modal) {
          modal.style.display = 'none';
        }
      }, 3000);
    } else {
      triggerModal(errId);
    }
  }
};

export const triggerModal = id => {
  const {CBModal} = window.cb.apricot;
  CBModal({elem:id}).show();
};

export const closeModal = id => {
  const {CBModal} = window.cb.apricot;
  CBModal({elem:id}).close();
};

export const triggerToaster = msg => {
  const {CBToast} = window.cb.apricot;
 
  CBToast({
    message: msg,
    successIcon: true,
    bottom:true,
    autoClose:false
  });
};

export const getUniqueOrgData = ({orgid_roles, orgData, newrole}) => {
  //next two lines get the actual organization data relating to the user oid
  const unique_data = orgid_roles?.find(el => el.rid===newrole);
  const unique_org = orgData?.find(el => el.org_id === parseInt(unique_data.oid));
  return unique_org;
};
export const getModuleStatusStr = (moduleStatus, updatedAt,questionlevel=false) => {
  //2021-04-06T14:41:02.657Z to be 'April 06, 2021'
  if(!updatedAt) {
    return '';
  }
  if(!moduleStatus) {
    return '';
  }
  if(moduleStatus===UNMODIFIED) {
    return UNMODIFIED;
  }
  try{
    const datestr = new Date(updatedAt).toDateString();
    const arr = datestr.split(' ');
    if(!questionlevel){
      return `${moduleStatus} on ${arr[1]} ${arr[2]}, ${arr[3]}`;
    }
    else{
      return `${moduleStatus} ${arr[1]} ${arr[2]}, ${arr[3]}`;
    }
  }catch(e) {
    return '';
  }
};

export const removeSpace = str => {
  let res = '';
  for(let i=0; i<str.length; i++) {
    if(str[i] !== ' ') {
      res += str[i];
    }
  }
  return res;
};

export const smartAddToList = (arr1, arr2) => {
  //console.log('START--------', {arr1, arr2});
  if(arr1.length ===0) {
    arr1.push(...arr2);
    return arr1;
  } else {
    let index = -1;
    arr1.forEach((obj, ind) => {
      arr2.forEach(obj2 => {
        //if(Object.keys(obj)[0]===Object.keys(obj2)[0]) {
        if(obj['qid']===obj2['qid']) {
          index = ind;
        }
      });
      arr1[index] = arr2[0];
    });
    if(index < 0) {
      arr1.push(...arr2);
    }
    return arr1;
  }

};

export const addallMajors = (ori_Arr, new_Arr) => {
  let temp = []; const temp2 = [];//defined
  //push ori_arr if not empty into temp
  if(ori_Arr&&ori_Arr.length>0) {
    temp = [...ori_Arr];
  }
  //if temp is empty
  if(temp.length===0) {
    //push new_Arr into temp - new_Arr will ALWAYS have itesm
    new_Arr.forEach(({majors}) => {
      majors.forEach(({name, qid}) => temp.push({name, boxChecked :true, qid, degrees:[null, null, null, null, null, null, null, null, null], new: true, modified: true}));
    });
  }else {
    //push new_Arr into temp2 for formatting reasons.
    new_Arr.forEach(({majors}) => {
      majors.forEach(({name, qid}) => temp2.push({name, boxChecked:true, qid, degrees:[null, null, null, null, null, null, null, null, null], new: true, modified: true}));
    });
    /**
     * for each value in temp2 - we want to add it to temp if
     * 1. it does not exist
     * 2. it does exist but the boolean is different, in this case REPLACE it
     */
    // criteria one
    const qid1 = temp.map(({qid}) => qid);
    temp2.forEach(obj2 => {
      if(!qid1.includes(obj2.qid)) {
        temp.push(obj2);
      }
    });
    // criteria two
    temp2.forEach(obj2 => {
      temp.forEach((obj, index) => {
        if(obj.qid===obj2.qid && JSON.stringify(obj)!==JSON.stringify(obj2)) {
          //this means one is true and the other is false even tho they equal;
          temp.splice(index, 1);//remove the old one
          temp.push(obj2); //add the new one
        }
      });
    });
  }
  return temp;
};

export const countTrueValues = arr => {
  // arr = [{physics.01: false, qid: '...'}, {english.02: true, qid: '...'}, {biology.02: true, qid: '...'}, {chemistry.02: null, qid: '...'}, ...]
  let count = 0;
  arr.forEach(el => {
    if(Object.values(el)[0]===true && Object.keys(el)[0] !== '00000 - use for initializing') {
      count++;
    }
  });
  return count;
};

export const sorter = (arr, property = 'sequence') => {
  return arr?.sort(
    (a, b) => {          
      if (a[property] === b[property]) {
        return 0;
      }
    return a[property] > b[property] ? 1 : -1;
  });
};

export const lastSavedDate = (mods, text) =>{
  let max= '';
  for(let mod of mods){
    if(max===''||compareDate(max, mod.last_updated_at)>0){
      max = mod.last_updated_at;
    }
  }

  return getModuleStatusStr(text, max);

};

export const determineLastModified = (modules, categoryData, categoryId) => {
  const current = categoryData.find(c => c?.id === categoryId);
  if((current?.status?.toUpperCase() === SUBMITTED_FOR_REVIEW || current?.status?.toUpperCase() === PUBLISHED)){
    const formattedStatus = current?.status.toLowerCase().split(' ').map((s) =>
    s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
    const currentStatus = formattedStatus.toUpperCase() === PUBLISHED ? 'Accepted' : formattedStatus;
    return getModuleStatusStr(currentStatus, current?.last_updated_at);
  }
  //Default return value
  return lastSavedDate(modules, 'Saved');
};

export const updateYear = (text) => {
  if(text != ''){
    let arr = text.split('-');
    return (arr.length < 3) ?  `${arr[2]}/${arr[0]}/${arr[1]}` : `${arr[0]}/${arr[1]}/${arr[2]}`;
  } 
};
//Returns reference value with reference code (reference table)
export const getRefValue = (refArr, refCode) => {
  let value = '';
  refArr?.forEach(el => {
    if (el.code === refCode) {
      value =(el.value);
    }
  });
  return value || -1;
};

export const dateAndTimeFormatter = (rawDate) => {
  try{

    const date = new Date(rawDate);
    
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
    return formattedDate;
  } catch(error){
      return '';
  }
};

export const openWindow = (url) => (url.trim()) && window.open(url, '_blank');